<template>
  <div></div>
  <!-- <div class="common-bottom-banner">
      <img @click="goBtn()" src="@/assets/images/hot-activity-lately-banner.png" alt="">
  </div> -->
</template>

<script>
  export default {
    methods: {
      goBtn() {
        this.$test('hot-activity')
        window.location.href = 'http://www.diyelf.com/srcb_hct/'
        // window.location.href = 'https://billcloud.unionpay.com/upwxs-rsad/adRight/adRightDetail?id=135&backallrights=true'
      }
    }
  }
</script>

<style lang="less" scoped>

</style>